import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100% !important;
  background-color: var(--white);
  margin: 90px 0px 0px 0px;

  .maxWidthContainer {
    max-width: 1270px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
  }

  // Title
  div h2 {
    width: 100%;
    text-align: left;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    letter-spacing: -0.015em;
    margin: 0px 0px 20px 0px;
  }

  .dataContainer {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  // Adress Data
  .dataContainer p {
    text-align: left;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    margin: 20px 30px 0px 0px;
    display: flex;
    align-content: center;
    align-items: center;
  }

  .dataContainer p strong {
    margin-right: 5px;
  }

  .dataContainer p span {
    margin: 3px 10px 0px 0px;
    font-size: 20px;
    color: var(--orange);
  }

  #email a {
    text-decoration: none;
    color: var(--orange) !important;
    transition: 0.1s all;
  }

  #email a:hover {
    color: var(--black) !important;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    div h2 {
      font-size: 2em;
    }

    // Adress Data
    .dataContainer p {
      font-size: 0.96em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    max-width: 1100px;
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    div h2 {
      font-size: 2em;
    }

    // Adress Data
    .dataContainer p {
      font-size: 0.96em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 1000px;
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 600px;
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 540px;
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 480px;
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;
  }
`;

export default Container;
